/* src/components/HistorialView.jsx */
import React from "react";

export default function HistorialView(props) {
  return (
    <div style={{ padding: 30, textAlign: "center", fontSize: 18 }}>
      <p>Contenido de la sección <strong>Historial</strong> por definirse...</p>
    </div>
  );
}
